import {CSTReleaseMeta, CSTRelease} from '../../../services/types'

export const getCurrentReleaseMeta = (releases: CSTReleaseMeta[]): CSTRelease => {
  const notDeployedRelease = releases.find(({releaseDate, isActiveRelease}) => !releaseDate && !isActiveRelease)
  const activeRelease = releases.find(({isActiveRelease}) => isActiveRelease)
  const currentRelease = (notDeployedRelease || activeRelease) as CSTRelease
  return currentRelease
}
